var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTimelapse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "timelapse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.3,
    d: "M16 5.31995C10.1067 5.31995 5.33337 10.0933 5.33337 15.9866C5.33337 21.8799 10.1067 26.6533 16 26.6533C21.8934 26.6533 26.6667 21.8799 26.6667 15.9866C26.6667 10.0933 21.8934 5.31995 16 5.31995ZM21.6667 21.6399C18.5334 24.7599 13.4667 24.7599 10.3467 21.6399L16 15.9866V7.98661C18.0534 7.98661 20.0934 8.77328 21.6534 10.3333C24.7867 13.4533 24.7867 18.5199 21.6667 21.6399Z",
    fill: "#29ABE2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.6533 10.3333C20.0933 8.77332 18.0533 7.98665 16 7.98665V15.9867L10.3466 21.64C13.4666 24.76 18.5333 24.76 21.6666 21.64C24.7866 18.52 24.7866 13.4533 21.6533 10.3333ZM16 2.65332C8.63996 2.65332 2.66663 8.62665 2.66663 15.9867C2.66663 23.3467 8.63996 29.32 16 29.32C23.36 29.32 29.3333 23.3467 29.3333 15.9867C29.3333 8.62665 23.36 2.65332 16 2.65332ZM16 26.6533C10.1066 26.6533 5.33329 21.88 5.33329 15.9867C5.33329 10.0933 10.1066 5.31999 16 5.31999C21.8933 5.31999 26.6666 10.0933 26.6666 15.9867C26.6666 21.88 21.8933 26.6533 16 26.6533Z",
    fill: "#29ABE2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelapse);
export default __webpack_public_path__ + "static/media/timelapse.4e1b0d81790c9ddecf6efa06f77e5838.svg";
export { ForwardRef as ReactComponent };